<template>
  <div class="tab-item-content">
    <InfoDialog v-model="showModal" :lang="lang" />

    <!-- Title -->
    <v-text-field
      :label="$t('ARTWORK_UPLOAD.STEP_2_TABS.TITLE', lang)"
      flat
      box
      v-model="form.title[lang]"
      :error-messages="errors['title.'+lang]"
    >
      <template v-slot:append-outer>
        <v-tooltip dark bottom max-width="300px">
          <template v-slot:activator="{ on }">
            <v-icon size="20" color="primary" v-on="on">fas fa-info-circle</v-icon>
          </template>
          <span>{{ $t('TOOLTIP.ARTWORK_UPLOAD_FORM.TITLE') }}</span>
        </v-tooltip>
      </template>
    </v-text-field>

    <div v-html="$t('ARTWORK_UPLOAD.STEP_2_TABS.DESCRIPTION_INFO', lang)"></div>

    <div class="pl-2">
      <v-radio-group v-model="description_alternative">
        <v-layout row wrap>
          <v-flex xs12 sm6 md3 v-for="alt in description_alternatives" :key="alt.value">
            <v-radio :ripple="false" :label="alt.label" :value="alt.value" color="primary" />
          </v-flex>
        </v-layout>
      </v-radio-group>
    </div>

    <!-- Description -->
    <div class="mt-2">
      <v-textarea
        v-model="form.description[lang]"
        persistent-hint
        counter
        flat
        box
        rows="10"
        :error-messages="errors['description.'+lang]"
        :label="$t('ARTWORK_UPLOAD.STEP_2_TABS.DESCRIPTION')"
      />
    </div>
  </div>
</template>

<script>
import InfoDialog from "./InfoDialog.vue";

export default {
  components: { InfoDialog },
  props: ["form", "errors", "lang"],
  data() {
    return {
      showModal: false,
      description_alternative: "",
      description_alternatives: [
        {
          label: `${this.$t("ARTWORK.PAINTINGS")} (${this.$t(
            "TOOLTIP.ARTWORK.HANG",
            this.lang
          )})`,
          value: "AUTOFILL_PANTING_HANG_READY",
        },
        {
          label: `${this.$t("ARTWORK.PAINTINGS")} (${this.$t(
            "TOOLTIP.ARTWORK.NO_HANG",
            this.lang
          )})`,
          value: "AUTOFILL_PANTING_NOT_HANG_READY",
        },
        {
          label: this.$t("ARTWORK_UPLOAD.PRINT_AND_PHOTO", this.lang),
          value: "AUTOFILL_PRINT_AND_PHOTO",
        },
        {
          label: `${this.$t("ARTWORK.SCULPTURE", this.lang)}`,
          value: "AUTOFILL_SCULPTURE",
        },
      ],
    };
  },

  watch: {
    description_alternative: function (val, oldval) {
      this.fillDescription(val, oldval);
    },
  },

  mounted() {
    this.$nextTick(() => {
      const el = document.getElementById(
        `description-info-dialog-${this.lang}`
      );

      if (el) {
        el.addEventListener("click", (e) => {
          e.stopPropagation();
          this.showModal = true;
        });
      }
    });
  },
  methods: {
    async fillDescription(val, oldVal) {
      if (!this.isDescriptionTextFromTemplate(oldVal)) {
        const confirm = await this.$root.$confirm(
          this.$t("ARTWORK_UPLOAD.STEP_2_TABS.REPLACE_CONTENT_ALERT_TITLE"),
          this.$t("ARTWORK_UPLOAD.STEP_2_TABS.REPLACE_CONTENT_ALERT_DESC")
        );
        if (!confirm) return;
      }

      this.form.description[this.lang] = this.$t(
        `ARTWORK_UPLOAD.STEP_2_TABS.${val}`,
        this.lang
      );
    },

    isDescriptionTextFromTemplate(val) {
      const description = this.form.description[this.lang];
      const template = val
        ? this.$t(`ARTWORK_UPLOAD.STEP_2_TABS.${val}`, this.lang).toString()
        : "";

      const tmpl = template.trim().toLowerCase();
      const formDesc = description ? description.trim().toLowerCase() : "";

      return tmpl === formDesc;
    },
  },
};
</script>
<style lang="scss">
.tab-item-content {
  .description-info-dialog {
    text-decoration: underline;
  }
}
</style>